// 环境配置
interface EnvironmentConfig {
  API_BASE_URL: string
  API_TIMEOUT: number
  ENABLE_LOGGING: boolean
}

// 开发环境配置
const developmentConfig: EnvironmentConfig = {
  API_BASE_URL: "https://gw.jamerly.net", // 开发环境API地址
  API_TIMEOUT: 10000,
  ENABLE_LOGGING: true,
}

// 生产环境配置
const productionConfig: EnvironmentConfig = {
  API_BASE_URL: "https://gw.jamerly.net", // 生产环境API地址
  API_TIMEOUT: 15000,
  ENABLE_LOGGING: false,
}

// 根据当前环境选择配置
const getConfig = (): EnvironmentConfig => {
  const env = import.meta.env.MODE || "development"
  
  switch (env) {
    case "production":
      return productionConfig
    case "development":
    default:
      return developmentConfig
  }
}

export const config = getConfig()

// 导出单个配置项，方便使用
export const API_BASE_URL = config.API_BASE_URL
export const API_TIMEOUT = config.API_TIMEOUT
export const ENABLE_LOGGING = config.ENABLE_LOGGING 
